import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { initializeState, reportCleared } from "./sdlcReportSlice";
import { restoreState } from "./utils";
export const initFilter = {
    assessment_category: "ALL",
    policy_category: "ALL",
    policy_state: "ALL",
    is_audit_present_only: false,
};
export const initSort = {
    property: "id",
    reverse: false,
};
export const initPagination = {
    currentPage: 1,
    itemsPerPage: 10,
};
export const initialState = {
    filter: initFilter,
    sort: initSort,
    pagination: initPagination,
    expandedRows: [],
    focusedRow: null,
    filteredByLink: false,
};
const policiesSlice = createSlice({
    name: "policies",
    initialState: initialState,
    reducers: {
        filterUpdated: (state, action) => {
            state.filter = action.payload;
            state.filteredByLink = false;
            state.pagination.currentPage = 1;
            state.expandedRows = [];
            state.focusedRow = null;
        },
        policyStateFiltered: (state, action) => {
            state.filter = { ...initFilter, policy_state: action.payload };
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
            state.expandedRows = [];
            state.focusedRow = null;
        },
        assessmentCategoryWithStateFiltered: (state, action) => {
            state.filter = { ...initFilter, ...action.payload };
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
            state.expandedRows = [];
            state.focusedRow = null;
        },
        sortUpdated: (state, action) => {
            state.sort = action.payload;
            state.pagination.currentPage = 1;
            state.expandedRows = [];
            state.focusedRow = null;
        },
        paginationUpdated: (state, action) => {
            state.pagination = action.payload;
            state.expandedRows = [];
            state.focusedRow = null;
        },
        focusedRowUpdated: (state, action) => {
            state.focusedRow = action.payload;
        },
        expandedRowsUpdated: (state, action) => {
            if (action.payload.expand) {
                state.expandedRows.push(action.payload.id);
            }
            else {
                state.expandedRows = state.expandedRows.filter((id) => id !== action.payload.id);
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initializeState, (state, action) => {
            return restoreState(state, action.payload, "policies");
        });
        builder.addCase(reportCleared, () => {
            return cloneDeep(initialState);
        });
    },
});
export const policiesReducer = policiesSlice.reducer;
export const { filterUpdated, assessmentCategoryWithStateFiltered, policyStateFiltered, sortUpdated, paginationUpdated, expandedRowsUpdated, focusedRowUpdated, } = policiesSlice.actions;
export const selectFilter = (state) => state.report.policies.filter;
export const selectSort = (state) => state.report.policies.sort;
export const selectPagination = (state) => state.report.policies.pagination;
export const selectExpandedRow = (state, id) => state.report.policies.expandedRows.includes(id);
export const selectFocusedRow = (state) => state.report.policies.focusedRow;
export const selectFilteredByLink = (state) => state.report.policies.filteredByLink;
//# sourceMappingURL=policiesSlice.js.map